import React from "react";
import { Link } from "react-router-dom";
import articles from "../../data/articles";
import services from "../../data/services";
import accountingPhoto from "../../assests/office.webp";
import "./Blogs.css";

export const ArticlePage = ({ article }) => {
  const relatedArticle = articles.find((item) => item.path !== article.path);
  const relatedServices = services.filter((service) => article.relatedServices?.includes(service.path));

  return (
    <article className="thas-article" aria-labelledby="article-heading">
      <div className="site-container">
        <nav className="thas-blog-breadcrumb" aria-label="Brödsmulor">
          <ol>
            <li><Link to="/">Hem</Link></li>
            <li><Link to="/blogg">Kunskap & guider</Link></li>
            <li aria-current="page">{article.title}</li>
          </ol>
        </nav>
        <header className="thas-article-header">
          <p className="site-eyebrow">{article.category}</p>
          <h1 id="article-heading">{article.title}</h1>
          <p className="thas-article-lead">{article.introduction}</p>
        </header>
        <img
          className="thas-article-image"
          src={accountingPhoto}
          alt="Tre personer går igenom diagram och underlag vid en dator."
          width="1200"
          height="402"
          loading="lazy"
          decoding="async"
        />
        <div className="thas-article-layout">
          <div className="thas-article-content">
            {article.sections.map((section) => (
              <section key={section.id} aria-labelledby={section.id}>
                <h2 id={section.id}>{section.title}</h2>
                {section.paragraphs.map((paragraph) => <p key={paragraph}>{paragraph}</p>)}
                {section.bullets && <ul>{section.bullets.map((bullet) => <li key={bullet}>{bullet}</li>)}</ul>}
              </section>
            ))}
            {relatedServices.length > 0 && <nav aria-labelledby="article-services-heading">
              <h2 id="article-services-heading">Hjälp med det du har läst om</h2>
              <ul>{relatedServices.map((service) => (
                <li key={service.path}><Link className="site-text-link" to={service.path}>{service.title} <span aria-hidden="true">↗</span></Link></li>
              ))}</ul>
            </nav>}
            <aside className="thas-article-contact" aria-labelledby="article-contact-heading">
              <h2 id="article-contact-heading">Hur kan vi hjälpa dig?</h2>
              <p>Berätta om ditt företag och vilka delar av redovisningen du vill ha hjälp med.</p>
              <Link to="/#contact" className="site-button">Kontakta THAS <span aria-hidden="true">↗</span></Link>
            </aside>
          </div>
          <aside className="thas-article-sidebar">
            <nav aria-label="I den här guiden">
              <h2>I den här guiden</h2>
              <ol>
                {article.sections.map((section) => <li key={section.id}><a href={`#${section.id}`}>{section.title}</a></li>)}
              </ol>
            </nav>
            {relatedArticle && (
              <div className="thas-article-related">
                <h2>Läs också</h2>
                <Link to={relatedArticle.path}>{relatedArticle.title} <span aria-hidden="true">↗</span></Link>
              </div>
            )}
          </aside>
        </div>
        <Link to="/blogg" className="site-text-link thas-article-back"><span aria-hidden="true">←</span> Alla guider</Link>
      </div>
    </article>
  );
};

const Blog1 = () => <ArticlePage article={articles[0]} />;

export default Blog1;
